export default __webpack_public_path__ + "static/media/memoseq_responsive.2b93818e.png";